<template>
  <div>
    <div>
      <div style="position: relative; overflow:hidden;">
        <div class="bg-image">
          <img :src="imgURL" />
        </div>
        <b-container class="detailText" align="center">
          <b-row>
            <b-col cols="12">{{ currentCurriculum.title }}</b-col>
            <b-col cols="12">
              <h1>{{ currentCurriculum.catchPhrase }}</h1>
            </b-col>
            <b-col cols="12">
              <p v-html="currentCurriculum.subtitle"></p>
            </b-col>
            <b-col>
              <b-img rounded="circle" src="https://picsum.photos/250/250/?image=54"></b-img>
            </b-col>
            <b-col cols="12">
              <p v-html="currentCurriculum.quote"></p>
            </b-col>
            <b-col cols="12">
              <p>{{ currentCurriculum.student }}</p>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <b-container align="center">
      <b-row align-h="center">
        <b-col cols="12">아직 믿지 못하신다구요?</b-col>
        <b-col cols="8" style="background-color:#4E9BFF; color: white; border-radius: 25px">
          <b-row>
            <b-col cols="6">
              코더스하이와 함게라면
              <strong>상상은 현실이 됩니다.</strong>
            </b-col>
            <b-col cols="6">
              <b-img src="src/assets/images/etc/smarphone_hand.png"></b-img>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <CurriculumTrackIntroduction></CurriculumTrackIntroduction>
  </div>
</template>

<script>
import CurriculumTrackIntroduction from "@/components/curriculum-components/CurriculumTrackIntroduction.vue";

export default {
  props: ["id"],
  components: {
    CurriculumTrackIntroduction
  },
  data() {
    return {
      curricula: {},
      currentCurriculum: {},
      imgURL: require("@/assets/images/etc/bgImage.jpg")
    };
  },
  created() {
    this.curricula = [
      {
        id: 0,
        data: {
          title: "[iOS 앱 디자인과 개발과정]",
          catchPhrase: "야, 너도 앱 만들 수 있어!",
          subtitle: "iOS 앱 디자인과 앱 개발 과정을 통해 \n 앱의 기획, 디자인, 개발 프로세스를 학습할 수 있습니다. \n 코더스하이의 교육 과정은 누구에게나 열려 있으며, \n 애플에서 인증한 교육자들이 iOS 앱개발 강의를 진행합니다."
            .split("\n")
            .join("<br />"),
          quote: "하나의 강좌로 기획, 디자인, 앱스토어에 앱을 올리는 것 까지 \n 앱개발 전 과정을 배울 수 있습니다."
            .split("\n")
            .join("<br />"),
          student: " 중앙대학교 유럽 어학부 신OO(2017년 수료 후 네이버 입사)",
          time: "120시간",
          description:
            "iOS 앱 디자인과 개발과정은 도전중심학습(CBL)을 기반으로 일상의 문제를 정의하고, 해결하는 앱을 제작 하는 법을 배웁니다.",
          prerequisite:
            "선수지식은 없습니다. 충분한 시간과 노력을 기울인다면 컴퓨터공학 비전공생들도 충분히 목표를 이룰 수 있습니다.",
          components: [
            {
              title: "프로그래밍 기초(Track 0)",
              description:
                "iOS 앱개발을 위해 필요한 Swift언어의 기초를 코더스하이의 다양한 교육 컨텐츠를 통해 학습하게 됩니다."
            },
            {
              title: "UX 디자인 (Track 1)",
              description:
                "현업의 개발자, 디자이너는 제한적인 동작을 하는 애플리케이션인 프로토타입 개발을 통해 다양한 시행착오를 겪으며 실패 확률이 적은 앱을 개발합니다."
            },
            {
              title: "앱 개발(Track 2)",
              description:
                "아이디어 찾기, 프로토타이핑 과정을 통해 만들어진 결과물을 바탕으로 맥을 활용한 실제 앱개발을 하게 됩니다. 프로그래밍은 온라인과정을 통해 학습하게 됩니다."
            }
          ]
        }
      },
      {
        id: 1,
        data: {
          title: "[가칭]코딩배우기",
          subtitle: "Apple은 Everyone Can Code (누구나 즐겁게 코딩, 줄여서 ECC)라는 이름으로 \n 모든 사람이 쉽고 재밌게 코딩에 접근 할 수 있도록 교육 컨텐츠를 만들었습니다. \n 코더스하이의 코딩배우기 코스는 애플의 ECC 컨텐츠를 활용하여 \n 문제를 정의하고 해결하는 과정을 제공합니다."
            .split("\n")
            .join("<br />"),
          time: "24시간",
          description: "[가칭 - 모두의 코딩]코딩배우기는 iPad 스위프트 플레이그라운드 컨텐츠를 활용하고, 언플러그드 활동을 합니다. \n [스위프트 플레이 그라운드 이미지]\n\n - 언플러그드 활동을 통해 프로그래밍의 기초를 익힙니다. \n - 코딩배우기 1에서는 명령어, 디버깅, 함수, 루프등을 배우게 됩니다. \n - 코딩 배우기 2에서는 변수, 상수, 타입, 콜렉션 타입을 배우게 됩니다. "
            .split("\n")
            .join("<br />"),
          prerequisite:
            "선수지식은 없습니다. 충분한 시간과 노력을 기울인다면 컴퓨터공학 비전공생들도 충분히 목표를 이룰 수 있습니다.",
          components: [
            {
              title: "코딩배우기 1 & 2",
              description:
                "iPad 플레이그라운드 코딩배우기 1과 2를 통해 iOS 앱개발에 사용되는 Swift 언어를 학습하게 됩니다."
            },
            {
              title: "언플러그드 활동",
              description:
                "코딩에 익숙하지 않은 학습자들이 \n 친숙하게 느끼는 일상사물들을 교보재로 활용해 프로그래밍의 \n 개념을 익힙니다."
            },
            {
              title: "커스텀 플레이 그라운드",
              description:
                "iPad 플레이그라운드의 드로잉과 코더스하이에서 개발한 플레이그라운드 컨텐츠를 통해 Swift 언어를 배우고 알고리즘적 사고를 함양할 수 있습니다."
            }
          ]
        }
      },
      {
        id: 2,
        data: {
          title: "App 기획자 UX 디자인 과정",
          subtitle: "앱 아이디어를 프로토타입으로 제작해 봄으로써, \n 앱 기획과 디자인 프로세스를 이해하게 됩니다. \n 코더스하이는 다양한 UI 가이드라인을 앱에 적용한 현장경험을\n 제공합니다."
            .split("\n")
            .join("<br />"),
          time: "64시간",
          description: "이 과정을 통해 다음을 학습하게 됩니다. \n - 디자인 씽킹으로 사고하고 애플리케이션으로 문제 해결하기 \n - 애플리케이션의 기획 단계에서 아이디어 정리 방법 \n - 사용자 인터페이스에 대한 가이드라인 \n - 인터페이스 설계 도구를 이용해 애플리케이션의 UI 제작하기 \n - 실제 디바이스에서 동작하는 프로토타입 완성하기"
            .split("\n")
            .join("<br />"),
          prerequisite:
            "선수지식은 없습니다. 충분한 시간과 노력을 기울인다면 컴퓨터공학 비전공생들도 충분히 목표를 이룰 수 있습니다.",
          components: [
            {
              title: "아이디어 정리하기",
              description:
                "애플의 디자인 가이드 라인과 Design Thinking을 활용한 UX 디자인 방식을 통해 학습자들은 자신이 만들고자 하는 앱 아이디어를 정리하게 됩니다."
            },
            {
              title: "도구 익히기",
              description:
                "Sketch, AdobeXD를 활용해 프로토타입을 만들고 서로에게 공유합니다."
            },
            {
              title: "프로토타입 만들기",
              description:
                "프로토타입 공유와 피드백의 과정을통해 최종 결과물들을 만들어 냅니다."
            }
          ]
        }
      }
    ];
    this.currentCurriculum = this.curricula.filter(
      e => e.id === this.id
    )[0].data;
  }
};
</script>

<style scoped>
.bgImage {
  background-size: cover;
  background-color: rgba(0, 0, 0, 0.5);
}
.bgImage:after {
  z-index: 1;
}
.bg-image {
  position: absolute;
  top: 0;
  height: 100%;
}
.bg-image > img {
  width: 100%;
  opacity: 0.5;
}
.detailText {
}
</style>
